import { Box } from '@/components';
import type { CSSProperties, FC } from 'react';
import type { TableRowType } from '../../../utils';
import { Table } from './Table';

type Props = {
  data: TableRowType;
  wrapperStyle?: CSSProperties | undefined;
  defaultDataLength?: number;
  noneBorder?: boolean;
};

/**
 * @deprecated
 * ReportTableを使うようにする
 */
export const TableContent: FC<Props> = ({
  data,
  wrapperStyle,
  defaultDataLength = 2,
  noneBorder,
}) => {
  // NOTE: Assumption that the header is displayed.
  const hasData = data.length >= defaultDataLength;
  return (
    <Box
      display={hasData ? 'block' : 'flex'}
      height={hasData ? undefined : '100%'}
      {...wrapperStyle}
    >
      <Table data={data} noneBorder={noneBorder} />
    </Box>
  );
};
